export default __webpack_public_path__ + "static/media/kitchen2-2048w.5c451b62.avif";